import React from "react";

const SwivuHomeMarketingMsg = () => (
  <>
    <h2 className="my-0 mt-[24px] text-2xl  font-bold text-gray-900 dark:text-white font-['poppins']">Welcome to Swivu HQ – Your Command Center</h2>
    <ul className="space-y-1 list-inside dark:text-gray-200 px-0 flex flex-col items-center mt-3 mb-3 text-center max-w-[620px]">
      {[
        "Coordinate resources, delegate tasks, segment clients, and herd your cats—Swivu HQ gives you the control and clarity to keep everything moving.",
      ].map((featureItem, idx) => (
        <li className="flex items-center text-base my-[0]" key={idx}>
          {featureItem}
        </li>
      ))}
    </ul>
  </>
)

export default SwivuHomeMarketingMsg;